<ion-header>
  <ion-toolbar>
    <ion-title>Piled</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  <div class="login-container">
    <div class="login-main-row">
      <!-- Logo/Header Section -->
      <div class="header-section">
        <div class="logo-container">
          <img src="assets/piled_logo.png" alt="Piled Logo" class="logo">
        </div>
        <h1>Welcome to Piled</h1>
        <p class="subtitle">Sign in to continue</p>
      </div>

      <!-- Login Form -->
      <div class="login-form">
      <div class="form-field">
        <ion-label position="stacked">Username</ion-label>
        <ion-item lines="none" class="input-item">
          <ion-input 
            type="text" 
            [(ngModel)]="username" 
            required
            [disabled]="isLoading"
            autocomplete="username"
            placeholder="Enter your username"
            class="custom-input">
          </ion-input>
        </ion-item>
      </div>

      <div class="form-field">
        <ion-label position="stacked">Password</ion-label>
        <ion-item lines="none" class="input-item">
          <ion-input 
            [type]="showPassword ? 'text' : 'password'" 
            [(ngModel)]="password" 
            required
            [disabled]="isLoading"
            autocomplete="current-password"
            placeholder="Enter your password"
            class="custom-input">
          </ion-input>
          <ion-button 
            fill="clear" 
            slot="end" 
            (click)="togglePasswordVisibility()"
            class="password-toggle-btn">
            <ion-icon 
              [name]="showPassword ? 'eye-off-outline' : 'eye-outline'"
              class="password-icon">
            </ion-icon>
          </ion-button>
        </ion-item>
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <ion-button 
        expand="block" 
        (click)="onLogin()" 
        [disabled]="!username || !password || isLoading"
        class="login-button">
        <ion-spinner name="dots" *ngIf="isLoading"></ion-spinner>
        <span>{{ isLoading ? 'Logging in...' : 'Login' }}</span>
      </ion-button>

      <div class="forgot-password-link">
        <a (click)="openForgotPasswordModal()">Forgot Password?</a>
      </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section">
      <ion-text color="medium">
        <p>Need help? Contact support</p>
        <p class="api-url-debug" *ngIf="!isProd">Environment: {{ environment.environmentName | titlecase }}</p>
        <p class="api-url-debug" *ngIf="!isProd">API URL: {{ apiUrl }}</p>
      </ion-text>
      <ion-text color="medium" class="app-version-text" *ngIf="appVersion">
        <p>Version {{ appVersion }}</p>
      </ion-text>
    </div>
  </div>

  <!-- Forgot Password Modal -->
  <ion-modal [isOpen]="showForgotPasswordModal" (didDismiss)="closeForgotPasswordModal()">
    <ng-template>
      <div class="modal-bg">
        <div class="modal-card">
          <div class="modal-header">
            <h2>Reset Password</h2>
            <p class="modal-subtitle">Enter your information to reset your password</p>
            <ion-button 
              fill="clear" 
              class="close-btn" 
              (click)="closeForgotPasswordModal()">
              <ion-icon name="close"></ion-icon>
            </ion-button>
          </div>

          <div class="modal-content">
            <!-- Request Code Step -->
            <div *ngIf="forgotStep === 'request'" class="step-container">
              <div class="form-group">
                <label class="modal-label">Username or Email</label>
                <input 
                  type="text" 
                  [(ngModel)]="forgotUsername" 
                  placeholder="Enter your username or email"
                  class="modal-input" />
              </div>

              <div class="error-message" *ngIf="forgotError">
                {{ forgotError }}
              </div>

              <button 
                class="primary-btn"
                (click)="onForgotPasswordRequest()"
                [disabled]="!forgotUsername || forgotLoading">
                <ion-spinner *ngIf="forgotLoading" name="crescent"></ion-spinner>
                <span>{{ forgotLoading ? 'Sending...' : 'Send Reset Code' }}</span>
              </button>
            </div>

            <!-- Confirm Code Step -->
            <div *ngIf="forgotStep === 'confirm'" class="step-container">
              <div class="form-group">
                <label class="modal-label">Reset Code</label>
                <input 
                  type="text" 
                  [(ngModel)]="forgotCode" 
                  placeholder="Enter the code sent to your email"
                  class="modal-input" />
              </div>

              <div class="password-requirements">
                Your password must be at least 8 characters long and contain:
                <ul>
                  <li>At least 1 uppercase letter</li>
                  <li>At least 1 lowercase letter</li>
                  <li>At least 1 number</li>
                  <li>At least 1 special character</li>
                </ul>
              </div>

              <div class="form-group">
                <label class="modal-label">New Password</label>
                <div class="password-input-container">
                  <input 
                    [type]="showForgotPassword ? 'text' : 'password'" 
                    [(ngModel)]="forgotNewPassword" 
                    placeholder="Enter your new password"
                    class="modal-input" />
                  <ion-icon 
                    [name]="showForgotPassword ? 'eye-off' : 'eye'" 
                    (click)="toggleForgotPasswordVisibility()"
                    class="password-toggle-icon">
                  </ion-icon>
                </div>
              </div>

              <div class="error-message" *ngIf="forgotError">
                {{ forgotError }}
              </div>

              <button 
                class="primary-btn"
                (click)="onForgotPasswordConfirm()"
                [disabled]="!forgotCode || !forgotNewPassword || forgotLoading">
                <ion-spinner *ngIf="forgotLoading" name="crescent"></ion-spinner>
                <span>{{ forgotLoading ? 'Resetting...' : 'Reset Password' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ion-modal>
</ion-content>
